import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AccountPlanConfig } from 'src/app/models/school/schooladminitem.model';
import { SchoolInformationview } from 'src/app/models/schoolinformationview.model';
//import { AccountPlanConfig } from 'src/app/models/billing/BillingAccountInfo';
import { BillingAccountService } from 'src/app/services/BillingAccount/billing-account.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-schoolplans',
  templateUrl: './schoolplans.component.html',
  styleUrls: ['./schoolplans.component.css']
})
export class SchoolplansComponent implements OnInit {
  accountPlans: AccountPlanConfig[] = [];
  schoolid: any;
  schooInfo: SchoolInformationview;
  selectedAccountPlan: AccountPlanConfig;

  constructor(public billService: BillingAccountService, public util: UtilService, public schoolmanagerservice: SchoolmanagementService, public activatedroute: ActivatedRoute, public toastr: ToastrService, public router:Router, public headerinfo:ComponentheaderService)
   {     this.headerinfo.setHeaderDisplay('School Plans', [ {displaytext: 'Account Settings', route: '/account/accountsettings'},{displaytext: 'School Plans', route: '/account/schoolplan'}], []) }


  async ngOnInit() {

    var data: any = await this.schoolmanagerservice.getSchoolDetails().toPromise();
    this.schooInfo = data.schoolInfo;
    let response: any = await this.billService.getAvailableSchoolPlans().toPromise().catch((err) => { this.toastr.error(err); return; });
    this.accountPlans = response;
    //console.log('account plans', this.accountPlans);
    this.accountPlans = this.accountPlans.filter((value, index) => {
      return value.display;
    });
    this.accountPlans = this.accountPlans.sort((a, b) => {
      if(a.sNo == b.sNo){
        return 0;
      }
      if(a.sNo < b.sNo){
        return -1;
      }
      if(a.sNo > b.sNo){
        return 1;
      }
    })
    this.setSelectedAccountPlan();
    //console.log(this.accountPLans);
    //console.log(response);
  }
  private setSelectedAccountPlan() {
    this.selectedAccountPlan = this.accountPlans.find((plan) => {
      return plan.id == this.schooInfo.accountTierId;
    });
  }

 async onPlanSelect(planid:any) {
   //debugger;
    if (this.schooInfo.id > 0){
      const previousPlanId = this.schooInfo.accountTierId;
      this.schooInfo.accountTierId= planid;
      try{
        await this.schoolmanagerservice.editSchool(this.schooInfo).toPromise();
      }
      catch{
        this.schooInfo.accountTierId = previousPlanId;
        return;
      }
      this.toastr.success("Plan Updated Successfully");
      //this.router.navigate(["/account/accountsettings"]);    
      document.location.href = '/account/accountsettings';
    }
  }
}
